import Home from "@/views/Home";

export default [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "about" */ '../../views/home/Login.vue'),
    },
    {
        path: '/register',
        name: 'Register',
        component: () => import(/* webpackChunkName: "about" */ '../../views/home/REgister.vue'),
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import(/* webpackChunkName: "about" */ '../../views/home/ForgotPassword.vue'),
    },
    {
        path: '/change-password',
        name: 'ChangePassword',
        component: () => import(/* webpackChunkName: "about" */ '../../views/home/changePassword.vue'),
    },

    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../../views/About.vue')
    },
    {
        path: '/politik.check',
        name: 'CheckPoll',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../../views/home/onlinePoll.vue')
    },
    {
        path: '/politik.2fa',
        name: 'Check2FA',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../../views/home/VotingCode.vue')
    },
    {
        path: '/politik-results',
        name: 'Results',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../../views/home/Results.vue')
    },
    {
        path: '/politik.online',
        name: 'OnlinePoll',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../../views/home/PollQuestions.vue')
    }
]